<template>
  <div>
    <uni-popup ref="drug" type="bottom" :mask-click="true" @maskClick="maskClick">
      <uni-card title="添加药品" :is-full="true">
        <div class="search">
          <uni-search-bar
            v-model="searchValue"
            :focus="showSearch"
            placeholder="请搜索药品（药品名称/拼音码）"
            @confirm="search"
            @oninput="onInput"
            @cancel="cancelAddDrug"
            @clear="clearDrug"
            @blur="blur"
          />
          <div v-if="drugList.length" class="drug_wrap">
            <scroll-view
              :upper-threshold="-50"
              :scroll-top="0"
              :scroll-y="true"
              :scroll-anchoring="true"
              style="height: 18.346667rem"
              @scrolltolower="getMoreList"
            >
              <div
                v-for="(item, i) in drugList"
                :key="i"
                class="drug_msg"
                @click="setDrugMsg(item)"
              >
                <div class="row_wrap">
                  <span :class="[{ mdrug: item.drugType === '3' }, 'drug_name']">
                    {{ item.commonName }}
                  </span>
                  <div class="add">
                    <span>添加</span>
                  </div>
                </div>
                <div v-if="item.drugType != '4'" class="specification">
                  <span :class="{ mdrug: item.drugType === '3' }">
                    {{ item.drugSpec }}
                  </span>
                </div>
                <!-- 中草药不显示生产厂家 -->
                <div v-if="item.drugType != '4'" class="manufacturer">
                  <span>{{ item.manufacturer }}</span>
                </div>
                <div class="row_wrap">
                  <span class="price">¥ {{ item.price }}</span>
                  <div>
                    <span class="medicalInsurance">
                      {{ judgeMedicalInsuranceType(item) }}
                    </span>
                    <span v-if="judgeMedicalInsuranceType(item)" class="line"></span>
                    <span class="stockQuantity"> 库存剩余：{{ item.stockQuantity }} </span>
                  </div>
                </div>
              </div>
              <div v-if="drugList[0] && isDone" class="isBottom">
                <span>已经到底啦～</span>
              </div>
            </scroll-view>
          </div>
          <div v-else class="drug_wrap">
            <GlNoContent title="暂无数据" />
          </div>
        </div>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <ms-drug-msg
      ref="drugmsg"
      :drug-msg="drugMsg"
      v-model:visible="showDrugMsg"
      :warehouseID="warehouseID"
      :ifUpdate="false"
      @showAddDrug="showAddDrug"
    />
  </div>
</template>

<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import { getDrugListByCache } from '@/views/funcPuzzle/utils/index.js'
// import MsDrugMsg from '@/views/funcPuzzle/components/ms-drug-msg/ms-drug-msg.vue'
// import GlNoContent from '@/views/funcPuzzle/home/components/gl-no-content'

export default {
  components: {
    // GlNoContent
    // MsDrugMsg
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    prescripType: {
      type: [Object, String],
      default: ''
    },
    warehouseID: {
      type: [String],
      default: ''
    }
  },
  data() {
    return {
      searchValue: '',
      drugList: [],
      showDrugMsg: false,
      drugMsg: '',
      showSearch: false,
      pageParams: {
        pageNum: '1',
        pageSize: '10'
      },
      isDone: false
    }
  },
  methods: {
    getKeyValueText,
    judgeMedicalInsuranceType(item) {
      if (!item.medicalInsuranceType && !item.throughCode) {
        return ''
      } else {
        return item.medicalInsuranceType
          ? getKeyValueText('medical_insurance', item.medicalInsuranceType)
          : item.throughCode
          ? '医保'
          : '非医保'
      }
    },
    maskClick() {
      this.close()
    },
    close() {
      if (!this.$refs.drug) {
        return false
      }
      this.showSearch = false
      this.$emit('update:visible', false)
      this.$refs.drug.close()
    },
    open() {
      this.$refs.drug.open()
      this.$emit('update:visible', true)
    },
    onInput() {
      this.search()
    },
    search(val) {
      this.pageParams.pageNum = '1'
      this.isDone = false
      this.getSymptomListByCache()
    },
    clearDrug(val) {},
    blur() {
      this.showSearch = false
    },
    getSymptomListByCache() {
      const map = {
        1: '2',
        2: '1',
        4: '3',
        3: '4',
        5: '5',
        6: '6',
        8: '8'
      }
      const drugType = map[this.prescripType]
      const params = {
        ...this.pageParams,
        searchKeyword: this.searchValue || null,
        drugType,
        state: '1',
        warehouseID: this.warehouseID
      }

      getDrugListByCache(params).then(rs => {
        if (rs.DrugList.length === 0) {
          this.isDone = true
        }
        if (params.searchKeyword) {
          if (this.pageParams.pageNum === '1') {
            this.drugList = rs.DrugList
          } else {
            this.drugList = this.drugList.concat(rs.DrugList)
          }
        } else {
          this.drugList = this.drugList.concat(rs.DrugList)
        }
      })
    },
    getMoreList() {
      this.pageParams.pageNum++
      if (!this.isDone) {
        this.getSymptomListByCache()
      }
    },
    setDrugMsg(item) {
      // 后续添加药品操作
      this.drugMsg = item
      item.drugFlag = new Date().getTime()
      this.$refs.drug.close()
      this.searchValue = ''
      this.drugList = []
      this.$emit('update:visible', false)
      // this.$refs.drugmsg.open()
      this.showDrugMsg = true
    },
    // 显示选择添加药品页面
    showAddDrug() {
      this.$refs.drug.open()
      this.search()
    },
    cancelAddDrug() {
      this.close()
      this.$bus.emit('cancelAddDrug', true)
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.showSearch = true
        this.$refs.drug.open()
        this.search()
      } else {
        this.searchValue = ''
        this.drugList = []
        this.close()
      }
    },
    prescripType(val) {},
    searchValue(val) {}
  },
  unmounted() {
    this.$bus.off('cancelAddDrug')
  }
}
</script>

<style scoped></style>
<style lang="scss" scoped>
.drug_wrap {
  height: 19.2rem;
  overflow-y: scroll;
  overflow-x: hidden;
  .drug_msg {
    display: flex;
    flex-direction: column;
    height: 4.906667rem;
    padding: 0.682667rem 0 0.426667rem 0;
    border-bottom: 0.021333rem solid #ececec;
    justify-content: center;
    margin-left: 0.682667rem;
    width: 14.634667rem;
    text:first-child,
    text:nth-child(2) {
      margin-bottom: 0.256rem;
    }
    .specification,
    .manufacturer {
      font-size: 0.512rem;
      font-weight: 400;
      color: #888888;
      margin-bottom: 0.597333rem;
    }
    .price {
      font-size: 0.64rem;
      font-weight: 400;
      color: #f86767;
      line-height: 0.704rem;
    }
    .row_wrap {
      display: flex;
      justify-content: space-between;
      .medicalInsurance {
        font-size: 0.64rem;
        font-weight: 400;
        color: #888888;
      }
      .line {
        display: inline-block;
        margin: 0rem 0.256rem -0.021333rem 0.170667rem;
        width: 0.042667rem;
        height: 0.554667rem;
        border-right: 0.021333rem solid #979797;
      }
      .stockQuantity {
        font-size: 0.64rem;
        font-weight: 400;
        color: #fea602;
      }
      .drug_name {
        font-size: 0.64rem;
        font-weight: 400;
        color: #222222;
        margin-bottom: 0.597333rem;
        margin-top: -0.128rem;
      }

      .add {
        background: #0089ff;
        width: 2.133333rem;
        height: 0.981333rem;
        border-radius: 0.085333rem;
        text-align: center;
        line-height: 0.981333rem;
        color: #fff;
        font-size: 0.64rem;
        font-weight: 400;
      }
    }
  }
  .isBottom {
    height: 2.133333rem;
    color: #888;
    text-align: center;
    line-height: 1.28rem;
  }
}
</style>
